export default {
  ok: 'OK',
  cancel: 'Cancel',
  close: 'Close',
  yes: 'Yes',
  no: 'No',
  credits: 'Credits',
  generalErrorMessage: 'Tech is as tech does. Difficult at times...',
  reload: 'Reload',
  submit: 'Submit',
  webGlNotSupported: 'This browser is behind the times. Try the latest Chrome browser.'
}
